import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useSelector } from 'react-redux';

import withdrawalSVG from 'shared/img/devaluation.svg';
import incomeSVG from 'shared/img/money-bag.svg';
import depositsSVG from 'shared/img/profit.svg';

const useIncomeData = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { total, depositsSum, withdrawalsSum } = useSelector(state => state.statistic.transfers, shallowEqual);

  return useMemo(
    () => [
      {
        icon: depositsSVG,
        title: locale.deposits,
        value: depositsSum,
        color: 'green',
      },
      {
        icon: withdrawalSVG,
        title: locale.withdrawals,
        value: withdrawalsSum,
        color: 'purple',
      },
      {
        icon: incomeSVG,
        title: locale.total,
        value: total,
        color: 'blue',
      },
    ],
    [total, depositsSum, withdrawalsSum, locale],
  );
};

const useBetsData = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { totalBetAmount, totalWinnings, totalGgr, totalBetsCount } = useSelector(
    state => state.statistic.bets,
    shallowEqual,
  );

  return useMemo(
    () => [
      {
        icon: depositsSVG,
        title: locale.totalBetAmount,
        value: totalBetAmount,
        color: 'green',
      },
      {
        icon: withdrawalSVG,
        title: locale.totalWinnings,
        value: totalWinnings,
        color: 'purple',
      },
      {
        icon: incomeSVG,
        title: locale.totalGGR,
        value: totalGgr,
        color: 'blue',
      },
    ],
    [totalBetAmount, totalWinnings, totalGgr, locale],
  );
};

const useDayFilters = () => {
  const locale = useSelector(state => state.locale.locale.dashboardLocale);

  return [
    {
      value: {
        to: 1,
        from: 0,
        id: 'today',
      },
      name: locale.today,
    },
    {
      value: {
        to: 0,
        from: -1,
        id: 'yesterday',
      },
      name: locale.yesterday,
    },
    {
      value: {
        to: 1,
        from: -6,
        id: 'week',
      },
      name: locale.week,
    },
    {
      value: {
        to: 1,
        from: -30,
        id: 'month',
      },
      name: locale.month,
    },
  ];
};

export { useIncomeData, useDayFilters, useBetsData };
